import './ClickLoadingIndicator.css'; // Optional CSS file for styling

import React from 'react';
import spinnerSvgPath from '../../assets/images/spinner.svg';

interface ClickLoadingIndicatorProps {
  isLoading: boolean;
  type: 'page' | 'thumb';
  width?: number;
  height?: number;
}

export const ClickLoadingIndicator: React.FC<ClickLoadingIndicatorProps> = ({
  isLoading,
  type = 'page',
  width,
  height,
}) => {
  return isLoading ? (
    <div
      role="loading-spinner"
      className={
        type === 'page'
          ? 'fixed inset-0 z-50 flex items-center justify-center overflow-x-hidden overflow-y-auto outline-none'
          : 'image z-50 flex items-center justify-center'
      }
    >
      <div
        className={
          type === 'page' ? 'fixed inset-0 transition-opacity bg-gray-200 opacity-50 page' : 'thumb'
        }
      ></div>
      <div className={`loading-indicator ${isLoading ? 'show' : ''}`}>
        <img
          className={`spinner ${type} select-none`}
          src={spinnerSvgPath}
          alt="Loading..."
          draggable={false}
          tabIndex={-1}
          style={
            {
              '--cli-spinner-width': `${width ?? (type === 'thumb' ? 50 : 80)}px`,
              '--cli-spinner-height': `${height ?? (type === 'thumb' ? 50 : 80)}px`,
            } as React.CSSProperties
          }
        />
      </div>
    </div>
  ) : null;
};
